module.exports = __webpack_public_path__ + "img/chevron-right.cbc38250.svg";